import { render, staticRenderFns } from "./Logout.vue?vue&type=template&id=1b94796e&scoped=true"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"
import style0 from "./Logout.vue?vue&type=style&index=0&id=1b94796e&prod&lang=sass"
import style1 from "./Logout.vue?vue&type=style&index=1&id=1b94796e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b94796e",
  null
  
)

export default component.exports